import type { Action } from "redux";

import type { NodeId } from "~/models/dto";
import { type Observable, type Subscription, map } from "~/tools/rxjs";
import type { SparseArrayChangedEvent } from "~/tools/sparse-array";

import type { GlobalChangedAction, GlobalChangedActionFactory } from "./GlobalChangedActionUtil";

export function mapArrayChangedEventToAction(
	actionFactory: GlobalChangedActionFactory,
	event: SparseArrayChangedEvent<NodeId, any>,
): GlobalChangedAction {
	if (event.type === "UPDATED") {
		return actionFactory({ addedOrUpdated: event.values });
	}

	return actionFactory({ deleted: event.keys });
}

export function dispatchActionOnArrayChangedEvent(
	actionFactory: GlobalChangedActionFactory,
	eventStream: Observable<SparseArrayChangedEvent<NodeId, any>>,
	dispatch: (action: Action) => void,
): Subscription {
	return eventStream.pipe(map((event) => mapArrayChangedEventToAction(actionFactory, event))).subscribe(dispatch);
}
